var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AxisBase } from './components/AxisBase';
import { Canvas } from '../components/Canvas';
export var Axis = function (_a) {
    var config = __rest(_a, []);
    var top = config.orientation === 'top'
        ? config.height
        : config.orientation === 'bottom'
            ? 0
            : config.top;
    return (React.createElement(React.Fragment, null, config.hide !== true && (React.createElement(React.Fragment, null, config.isCanvasChild === true ? (React.createElement(AxisBase, __assign({}, config))) : (React.createElement(Canvas, { height: config.height, margins: config.margins },
        React.createElement(AxisBase, __assign({}, config, { top: top }))))))));
};
//# sourceMappingURL=Axis.js.map